import { readAppLanguage } from '../../i18n';

// Keep the Korean layout; translated labels need their natural width and may wrap.
export default function localizedPeriodChipRowSx() {
    if (readAppLanguage() === 'ko') return {};
    return {
        flexWrap: 'wrap',
        '& .MuiChip-root': {
            flex: '1 1 auto',
            height: 'auto',
            minHeight: 42,
            maxWidth: '100%',
        },
        '& .MuiChip-root .MuiChip-label': {
            px: 1,
            py: 0.75,
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            textAlign: 'center',
        },
    };
}
